import React from 'react';

import { NumericForecastImage } from 'helper/products/meteorology';

import './index.scss';

const offsetOf = (period: string) => {
  const match = period.match(/\d+/);
  return match ? Number(match[0]) : 0;
};

export default function GridDays({
  model,
  images,
}: {
  model: string;
  images: NumericForecastImage[];
}) {
  const dayImages = images
    .filter((image) => image.model.toLowerCase() === model.toLowerCase())
    .slice()
    .sort((a, b) => offsetOf(a.period) - offsetOf(b.period));

  if (dayImages.length === 0) {
    return <p className="tf-pnt-mobile-grid-days-empty">Nenhuma imagem disponível para este modelo.</p>;
  }

  return (
    <div className="tf-pnt-mobile-grid-days">
      {dayImages.map((image) => (
        <div key={image.period} className="tf-pnt-mobile-grid-days-card">
          <span className="tf-pnt-mobile-grid-days-card-label">{image.period}</span>
          <img src={`data:image/png;base64,${image.base64}`} alt={`Mapa ${image.model} ${image.period}`} />
        </div>
      ))}
      <p className="tf-pnt-mobile-grid-days-hint">Role para baixo para mais dias</p>
    </div>
  );
}
